import styled from "styled-components";

export const StepsContent = styled.div`
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: calc(100vh - 290px);
  padding: 5px;
`;

export const StepsAction = styled.div`
  margin: 14px;
`;

////////////////////////////////////////

export const ThreeBox = styled.section`
  height: calc(30vh);
  min-height: 200px;
  width: 100%;
`;

///////////////////////////////////////

export const HeaderOptions = styled.h4`
  text-align: center;
`;

export const Label = styled.label`
  font-weight: 600;
`;

export const LabelValue = styled.label`
  font-weight: 700;
`;

export const LabelUnit = styled.label`
  font-weight: 400;
`;

export const FormItem = styled.div`
  &::first-letter {
    text-transform: uppercase;
  }
`;


///////////////////////////////////////

export const ResultContent = styled.div`
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  padding: 5px;
`;